import { routerNavigatedAction } from '@ngrx/router-store';
import { createReducer, on } from '@ngrx/store';
import { getUrl } from '@ngxp/rest';
import { createEmptyStateResource, createStateResource, StateResource } from '@schir-int-client/ngrx-helpers';
import {
	closeInProgressDialogAction,
	downloadSignaturAction,
	downloadSignaturSuccessAction,
	downloadSignaturTaskSuccessAction,
	loadSignaturValidatorResponseAction,
	loadSignaturValidatorResponseNotFoundAction,
	loadSignaturValidatorResponseSuccessAction,
	openInProgressDialogAction,
} from './signatur.actions';
import { SignaturLinkRel } from './signatur.linkrel';
import { SignatureResource, SignatureValidatorResponseResource, SignaturTaskResource } from './signatur.model';

export interface SignaturState {
	signaturTask: SignaturTaskResource;
	inProgressDialog: { isOpen: boolean };
	signatures: { [signatureUri: string]: StateResource<SignatureResource> };
	signatureValidatorResponse: StateResource<SignatureValidatorResponseResource>;
}

export const initialState: SignaturState = {
	signaturTask: null,
	inProgressDialog: { isOpen: false },
	signatures: {},
	signatureValidatorResponse: createEmptyStateResource(),
};

export const signaturReducer = createReducer(
	initialState,
	on(downloadSignaturTaskSuccessAction, (state: SignaturState, { signaturTask }): SignaturState => ({
		...state,
		signaturTask,
	})),
	on(openInProgressDialogAction, (state: SignaturState): SignaturState => ({
		...state,
		inProgressDialog: { ...state.inProgressDialog, isOpen: true },
	})),
	on(closeInProgressDialogAction, (state: SignaturState): SignaturState => ({
		...state,
		inProgressDialog: { ...state.inProgressDialog, isOpen: false },
	})),
	on(downloadSignaturAction, (state: SignaturState, { changeEntry }): SignaturState => ({
		...state,
		signatures: {
			...state.signatures,
			[getUrl(changeEntry, SignaturLinkRel.DOWNLOAD_SIGNATURE)]: createEmptyStateResource(true),
		},
	})),
	on(downloadSignaturSuccessAction, (state: SignaturState, { signatur, refUrl }): SignaturState => ({
		...state,
		signatures: {
			...state.signatures,
			[refUrl]: createStateResource(signatur),
		},
	})),
	on(loadSignaturValidatorResponseAction, (state: SignaturState): SignaturState => ({
		...state,
		signatureValidatorResponse: { ...state.signatureValidatorResponse, loading: true },
	})),
	on(loadSignaturValidatorResponseSuccessAction, (state: SignaturState, { response }): SignaturState => ({
		...state,
		signatureValidatorResponse: createStateResource(response),
	})),
	on(loadSignaturValidatorResponseNotFoundAction, (state: SignaturState): SignaturState => ({
		...state,
		signatureValidatorResponse: { ...createEmptyStateResource(), loaded: true },
	})),
	on(routerNavigatedAction, (state: SignaturState): SignaturState => ({
		...state,
		signatureValidatorResponse: createEmptyStateResource(),
		inProgressDialog: { ...state.inProgressDialog, isOpen: false },
	}))
);
